module.exports = __webpack_public_path__ + "static/media/txtbk_pj.b44ddce7.svg";